export const urlPathGet = (url: string | null, allowExternal = false) => {
  if (!url) return null;
  if (url.startsWith("/")) return url;

  try {
    const urlObj = new URL(url);
    if (allowExternal || urlObj.hostname === window.location.hostname) {
      return urlObj.pathname;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};

const urlIsRelative = (url: string): boolean => {
  return !/^(?:[a-zA-Z][\w+.-]*:|\/\/)/.test(url);
};

const urlIsAbsoluteAllowed = (url: string): boolean => {
  try {
    const u = new URL(url);
    if (u.protocol !== "http:" && u.protocol !== "https:") return false;

    const host = u.hostname.toLowerCase();
    if (host === "localhost") return true;

    return ["anymailfinder.com", "anymailfinder.xyz", "localhost"].some(
      (root) =>
        root !== "localhost" && (host === root || host.endsWith("." + root)),
    );
  } catch {
    return false;
  }
};

export const urlIsRedirectSafe = (target: unknown): boolean => {
  const t = typeof target === "string" ? target.trim() : "";

  return Boolean(t && (urlIsRelative(t) || urlIsAbsoluteAllowed(t)));
};
